import { Box, Text } from 'grommet';
import LevelTag from './LevelTag';
import PanelHeader from '../../common/PanelHeader';
import { Step } from '../../../types/Step';
import { useAppSelector } from '../../../../../redux';
import { getLatestUpdatedDate } from '../../../service/common/utils';

interface WizardHeaderProps {
  currentStep: Step;
}

const WizardHeader = ({ currentStep }: WizardHeaderProps) => {
  const fields = useAppSelector((state) => state.map.fields);
  const latestUpdatedInfo = getLatestUpdatedDate(fields);

  return (
    <>
      <Box direction={'row'} margin={'0.5rem 0 0 0'} justify={'between'} style={{ minHeight: '40px', minWidth: 'unset' }}>
        <Box direction={'row'} gap={'8px'} align={'center'} margin={{ right: '12px' }} style={{ minWidth: 'unset' }}>
          <Text weight={700} size={'1.5rem'} style={{ whiteSpace: 'nowrap' }}>
            {currentStep.title}
          </Text>
          {currentStep.levels.map((level) => (
            <LevelTag margin={'8px 0 0 0'} key={level} level={level} />
          ))}
        </Box>
        <PanelHeader />
      </Box>
      {currentStep.description && <Text margin={{ top: '1rem' }}>{currentStep.description}</Text>}
      {latestUpdatedInfo?.updatedAt && (
        <Box margin={'10px 10px 1rem 10px'}>
          <Text textAlign={'start'}>
            Updated by {latestUpdatedInfo?.updatedBy} at {latestUpdatedInfo?.updatedAt?.toLocaleDateString()}{' '}
            {latestUpdatedInfo?.updatedAt?.toLocaleTimeString()}
          </Text>
        </Box>
      )}
    </>
  );
};

export default WizardHeader;
